import { deleteDoc, doc, setDoc, type Firestore } from 'firebase/firestore'

export interface PushTokenDoc {
  token: string
  platform: 'android' | 'ios'
  deviceId: string
  updatedAt: string
  appVersion?: string
  lastUserEmail?: string
  enabled: boolean
}

function stripUndefined<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map((v) =>
      v && typeof v === 'object' ? stripUndefined(v as object) : v,
    ) as unknown as T
  }
  if (value && typeof value === 'object') {
    const result: Record<string, unknown> = {}
    for (const [key, v] of Object.entries(value as Record<string, unknown>)) {
      if (v === undefined) continue
      result[key] =
        Array.isArray(v) || (v && typeof v === 'object')
          ? stripUndefined(v as object)
          : v
    }
    return result as T
  }
  return value
}

export async function upsertPushToken(
  placeId: string,
  db: Firestore,
  tokenId: string,
  payload: PushTokenDoc,
): Promise<void> {
  const ref = doc(db, 'places', placeId, 'pushTokens', tokenId)
  await setDoc(ref, stripUndefined(payload), { merge: true })
}

export async function deletePushToken(
  placeId: string,
  db: Firestore,
  tokenId: string,
): Promise<void> {
  const ref = doc(db, 'places', placeId, 'pushTokens', tokenId)
  await deleteDoc(ref)
}
